export const RATE_PER_COMMIT = 25; // $25 per commit
export const RETAINER_PAID = 1500;
export const FIRESTORE_DOC_ID = 'overview';
export const FIRESTORE_COLLECTION = 'developer';
export const DEVELOPER_PASSCODE = '080808';
export const GITHUB_COMMITS_PER_PAGE = 100;
export const FIRESTORE_COMMITS_PREVIEW_LIMIT = 250;
export const FIRESTORE_COMMITS_QUERY_LIMIT = 5000;
export const FIRESTORE_COMMITS_PAGE_SIZE = 500;
export const COMMIT_ACTIVITY_WEEKS_DESKTOP = 52;
export const COMMIT_ACTIVITY_WEEKS_TABLET = 26;
export const COMMIT_ACTIVITY_WEEKS_MOBILE = 13;
